import { onAuthStateChanged } from 'firebase/auth'
import React, { createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../firebase/init'
import { getUser } from '../firebase/firestore'
import InitUser from '../components/InitUser'
import { User } from '../firebase/validator'
import { useQuery } from '@tanstack/react-query'
import { FirestoreError } from 'firebase/firestore'
import { ZodError } from 'zod'

export type UserWithID = User & {uid: string, isAdmin?: boolean}

export const AuthContext = createContext<UserWithID>(null as never)

type Props = {
  children: React.ReactNode
}
export const AuthProvider: React.FC<Props> = ({children})=> {
  const [userId, setUserId] = useState<string>('')
  const [isAdmin, setIsAdmin] = useState<boolean>(false)
  const navigate = useNavigate()
  const userQuery = useQuery<User | undefined, FirestoreError | ZodError>({
    queryKey: ['me'],
    queryFn: ()=> getUser(userId),
    enabled: Boolean(userId),
  })

  useEffect(()=> {
    const unsubscribe = onAuthStateChanged(
      auth,
      async auth_user=> {
        if (auth_user) {
          setUserId(auth_user.uid)
          // Check for admin custom claim
          const tokenResult = await auth_user.getIdTokenResult()
          setIsAdmin(Boolean(tokenResult.claims.admin))
        }
        else navigate('/login', { replace: true })
      },
      err=> { console.error(err) }
    )
    return unsubscribe
  }, [navigate])

  return !userId ?
    <div>Loading...</div>
    : !userQuery.data ?
      <InitUser userId={userId}/>
      :
      <AuthContext value={{...userQuery.data, uid: userId, isAdmin}}>
        {children}
      </AuthContext>
}

export const signOut = async ()=> {
  await auth.signOut()
  window.location.href = '/login'
}
